import { FormControl, FormLabel, Checkbox, Text, Card, CardBody } from '@chakra-ui/react';

import { withConfirm, SubHeading } from 'shared-components';

import { FundingSummary } from '../../../types';
import { dependantChildrenLabel } from '../../../utilities/sponsors';
import { useTranslation } from "react-i18next";

interface IProps {
  label: string;
  subLabel: string;
  fundingSummary: FundingSummary;
  sponsorshipCovers: Array<string>;
  onChange: (sponsorshipCovers: Array<string>) => void;
}

function FundingCoverSelect(props: IProps) {
    const { t } = useTranslation('common');
  const { label, subLabel, sponsorshipCovers, onChange } = props;
  const { courseFees, studentLivingCost, spouseLivingCost, childrenLivingCost } = props.fundingSummary;

  const hasFunding = (id: string) => sponsorshipCovers.includes(id);

  const toggleFunding = (id: string) => {
    const newCovers = sponsorshipCovers.filter(c => c !== id);
    if (!hasFunding(id)) newCovers.push(id);
    onChange(newCovers);
  };

  function renderCourseFee() {
    if (courseFees.length === 0) return null;

    return (
      <FormControl as="fieldset">
        <FormLabel as="legend">{t('common:courseFee')}</FormLabel>

        {courseFees.map((fund, i) => (
          <Checkbox
            key={i}
            isChecked={hasFunding(fund.label)}
            onChange={() => toggleFunding(fund.label)}
            variant="ghost"
            size="lg"
          >
            {fund.label}
          </Checkbox>
        ))}
      </FormControl>
    );
  }

  function renderStudentLivingCost() {
    if (studentLivingCost.amount === 0) return null;

    return (
      <FormControl as="fieldset">
        <FormLabel as="legend">{t('common:yourLivingCost')}</FormLabel>

        <Checkbox
          isChecked={hasFunding('studentLivingCost')}
          onChange={() => toggleFunding('studentLivingCost')}
          variant="ghost"
          size="lg"
        >
          {studentLivingCost.label}
        </Checkbox>
      </FormControl>
    );
  }

  function renderDependantLivingCost() {
    if (spouseLivingCost.amount === 0 && childrenLivingCost.amount === 0) return null;

    return (
      <FormControl as="fieldset">
        <FormLabel as="legend">{t('common:dependantSLivingCost')}</FormLabel>

        {spouseLivingCost.amount !== 0 && (
          <Checkbox
            isChecked={hasFunding('spouseLivingCost')}
            onChange={() => toggleFunding('spouseLivingCost')}
            variant="ghost"
            size="lg"
          >
            {t('common:partner')}
                              </Checkbox>
        )}

        {childrenLivingCost.amount !== 0 && (
          <Checkbox
            isChecked={hasFunding('childrenLivingCost')}
            onChange={() => toggleFunding('childrenLivingCost')}
            variant="ghost"
            size="lg"
          >
            {dependantChildrenLabel(childrenLivingCost.number)}
          </Checkbox>
        )}
      </FormControl>
    );
  }

  return (
    <div data-selector="funding-cover-select">
      <SubHeading>{label}</SubHeading>

      <Text color="muted">{subLabel}</Text>

      <Card variant="filled" borderRadius="lg">
        <CardBody display="flex" flexDirection="column" rowGap={4}>
          {renderCourseFee()}
          {renderStudentLivingCost()}
          {renderDependantLivingCost()}
        </CardBody>
      </Card>
    </div>
  );
}

export default withConfirm(FundingCoverSelect);
